import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import FieldText from '@atlaskit/field-text';
import Form, { Field } from '@atlaskit/form';
import Modal from '@atlaskit/modal-dialog';

// @source
import { fields } from '../../../../constants';
import { Messages } from '../../../components';
import { User as API } from '../../../../server';
import { User } from '../../../../tools';
import Styled from '../styled';

const initialState = {
  isLoading: false,
  message: false,
};

const initialStatic = {
  name: '',
  password: '',
  surname: '',
  username: '',
};

const getCompanyEmail = () => {
  const { Email } = User.getUserInfo();
  return Email.split('@')[1];
};

class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.company = getCompanyEmail();
    this.state = initialState;
    this.static = initialStatic;
    this.unmount = false;
    this.onCloseMessage = this.onCloseMessage.bind(this);
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
    this.registerField = this.registerField.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onCloseMessage() {
    this.setState({ message: false });
  }

  onSubmitHandle(event) {
    event.preventDefault();
    const validate = this.form.validate();

    if (!validate.isInvalid) {
      this.setState({
        isLoading: true,
        message: false,
      });

      API.create({
        data: [{
          ...this.static,
          username: `${this.static.username}@${this.company}`,
        }],
        dispatch: this.props.dispatch,
        success: (messages) => {
          this.reset();
          this.setStateUnmount({
            isLoading: false,
            message: (
              <Messages
                appearance="success"
                items={messages}
                onClose={this.onCloseMessage}
              />
            ),
          });
        },
        error: (messages) => {
          this.setStateUnmount({
            isLoading: false,
            message: (
              <Messages
                items={messages}
                onClose={this.onCloseMessage}
              />
            ),
          });
        },
      });
    }
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  setStatic(state) {
    this.static = { ...this.static, ...state };
  }

  reset() {
    const state = { value: '' };
    if (this.unmount) return;

    this.form.reset();
    this.setStatic(initialStatic);
    this.name.setState(state);
    this.password.setState(state);
    this.surname.setState(state);
    this.username.setState(state);
  }

  registerField(node) {
    if (this.form && node) {
      this.form.registerField(node.state.fieldState);
    }
  }

  render() {
    return (
      <Form
        name="create-user"
        onSubmit={this.onSubmitHandle}
        ref={(node) => { this.form = node; }}
      >
        <Modal
          heading="Create user"
          width="medium"
          onClose={this.props.onClose}
          actions={[{
            appearance: 'primary',
            isLoading: this.state.isLoading,
            onClick: this.onSubmitHandle,
            text: 'Create user',
            type: 'submit',
          }, {
            appearance: 'subtle',
            onClick: this.props.onClose,
            text: 'Cancel',
          }]}
        >
          <p>For to create a new user you enter the email and password of user.</p>
          <Styled.FieldGroup>
            <Field
              {...fields.name.field}
              ref={this.registerField}
            >
              <FieldText
                {...fields.name.fieldText}
                onChange={event => this.setStatic({ name: event.target.value })}
                ref={(node) => { this.name = node; }}
                value={this.static.name}
              />
            </Field>
            <Field
              {...fields.surname.field}
              ref={this.registerField}
            >
              <FieldText
                {...fields.surname.fieldText}
                onChange={event => this.setStatic({ surname: event.target.value })}
                ref={(node) => { this.surname = node; }}
                value={this.static.surname}
              />
            </Field>
          </Styled.FieldGroup>
          <Styled.FieldGroup>
            <Field
              {...fields.username.field}
              ref={this.registerField}
              helperText="Just enter your name"
            >
              <FieldText
                {...fields.username.fieldText}
                onChange={event => this.setStatic({ username: event.target.value })}
                ref={(node) => { this.username = node; }}
                value={this.static.username}
              />
            </Field>
            <Field label="Company Email">
              <FieldText
                disabled
                shouldFitContainer
                value={`@${this.company}`}
              />
            </Field>
          </Styled.FieldGroup>
          <Field
            {...fields.password.field}
            ref={this.registerField}
          >
            <FieldText
              {...fields.password.fieldText}
              onChange={event => this.setStatic({ password: event.target.value })}
              ref={(node) => { this.password = node; }}
              value={this.static.password}
            />
          </Field>
          {this.state.message}
        </Modal>
      </Form>
    );
  }
}

CreateUser.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(CreateUser);
